require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/fn/object/set-prototype-of.js
// module id = 517
// module chunks = 0 1